module.exports = __webpack_public_path__ + "img/1F1E9-1F1F2.9a492ce5.svg";